export const serieaggdata = [
  { name: "Somme", id: "SUM" },
  { name: "Moyenne", id: "AVG" },
  { name: "Max", id: "MAX" },
  { name: "Min", id: "MIN" },
]

export const datatypedata = [
  { name: "Nombre", id: "number" },
  { name: "Texte", id: "text" },
  { name: "Date", id: "date" },
]

export const typesdata = [
  { name: "Indicateur", id: "indicatorchart" },
  { name: "Histogramme", id: "columnchart" },
  { name: "Courbes", id: "linechart" },
  { name: "Aire", id: "areachart" },
  { name: "Multi-types", id: "composedchart" },
  { name: "Camembert", id: "piechart" },
  { name: "Tableau", id: "tab" },
  { name: "Tableau d'équipements", id: "tabequipment" },
  { name: "Heatmap", id: "heatmap" },
];

export const typestimedata = [
  { name: "Histogramme", id: "columnchart" },
  { name: "Courbes", id: "linechart" },
  { name: "Aire", id: "areachart" },
  { name: "Multi-types", id: "composedchart" },
  { name: "Heatmap", id: "heatmap" },
];

export const typesnotimedata = [
  { name: "Indicateur", id: "indicatorchart" },
  { name: "Histogramme", id: "columnchart" },
  { name: "Camembert", id: "piechart" },
  { name: "Tableau", id: "tab" },
  { name: "Tableau d'équipements", id: "tabequipment" },
];

export const typescomposedchart = [
  { name: "Histogramme", id: "column" },
  { name: "Courbes", id: "line" },
];

export const decalageunitdata = {
  '1h': [
    { name: "Heure", id: "h" },
    { name: "Jour", id: "d" },
    { name: "Mois", id: "M" },
  ],
  '1d': [
    { name: "Jour", id: "d" },
    { name: "Mois", id: "M" },
  ],
  '1M': [
    { name: "Mois", id: "M" },
  ]
};

export const realestatedata = [
  { name: "Surface", id: "surface", description: "Surface du groupe actuel ou de tous les groupes descendants" },
  { name: "Surface chauffée", id: "heatedsurface", description: "Surface chauffée du groupe actuel ou de tous les groupes descendants" },
];

export const grouptypechart = [
  { name: "Histogramme", id: "column" },
  { name: "Courbes", id: "line" },
];

export const grouptypechartdata = [
  { name: "Site", id: "site" },
  { name: "Bâtiment", id: "batiment" },
  { name: "Zone", id: "zone" },
  { name: "Compte", id: "compte" },
  { name: "Région", id: "région" },
  { name: "Equipement urbain", id: "equrbain" },
  { name: "EPCI", id: "epci" },
  { name: "Groupe", id: "groupe" },
  { name: "Commune", id: "commune" },
];

export const indicatorserietypedata = [
  { name: "Valeur de l'indicateur", id: "value" },
  { name: "Valeur de la tendance", id: "tendancy" },
  { name: "Valeur de la comparaison", id: "comparaison" },
];

export const agregategdatarealestate = [
  { name: "Somme", id: "SUM" },
  { name: "Moyenne", id: "AVG" },
  { name: "Maximum", id: "MAX" },
  { name: "Minimum", id: "MIN" },
  { name: "Nombre de valeurs", id: "COUNT" },
];

export const agregategdata = [
  { name: "Somme", id: "SUM" },
  { name: "Moyenne", id: "AVG" },
  { name: "Maximum", id: "MAX" },
  { name: "Minimum", id: "MIN" },
  { name: "Nombre de valeurs", id: "COUNT" },
  { name: "Nombre de valeurs distinctes", id: "COUNTDISTINCT" },
  { name: "Première valeur", id: "FIRST" },
  { name: "Dernière valeur", id: "LAST" },
];

export const timeresolutionindicdata = [
  { name: "Toutes les granularités", id: "all" },
  { name: "10 minutes", id: "10m" },
  { name: "1 heure", id: "1h" },
  { name: "1 jour", id: "1d" },
  { name: "1 mois", id: "1M" },
  { name: "1 an", id: "1y" },
];

export const pointgranularitydata = {
  'hour': [
    { name: "Automatique", id: "auto" },
    { name: "Horaire", id: "H" },
  ],
  'day': [
    { name: "Automatique", id: "auto" },
    { name: "Horaire", id: "H" },
    { name: "Journalier", id: "D" },
  ],
  'week': [
    { name: "Automatique", id: "auto" },
    { name: "Horaire", id: "H" },
    { name: "Journalier", id: "D" },
  ],
  'month': [
    { name: "Automatique", id: "auto" },
    { name: "Horaire", id: "H" },
    { name: "Journalier", id: "D" },
  ],
  'year': [
    { name: "Automatique", id: "auto" },
    { name: "Horaire", id: "H" },
    { name: "Journalier", id: "D" },
  ],
  'agg': [
    { name: "Automatique", id: "auto" },
    { name: "Horaire", id: "H" },
    { name: "Journalier", id: "D" },
  ],
};

export const pointtabgranularitydata = [
    { name: "Automatique", id: "auto" },
    { name: "Données brutes", id: "R" },
    { name: "Horaire", id: "H" },
    { name: "Journalier", id: "D" },
];

export const eqdatatypegranularitydata = [
  { name: "Journalier", id: "D" },
  { name: "Horaire", id: "H" },
  { name: "Données brutes", id: "raw" },
];

export const adanceddeffromdaydata = [
  { name: "Tous les jours", id: "all" },
  { name: "Tous les jours de la semaine", id: "weekdays" },
  { name: "Le samedi et dimanche", id: "weekenddays" },
  { name: "Du lundi", id: "2" },
  { name: "Du mardi", id: "3" },
  { name: "Du mercredi", id: "4" },
  { name: "Du jeudi", id: "5" },
  { name: "Du vendredi", id: "6" },
  { name: "Du samedi", id: "7" },
  { name: "Du dimanche", id: "1" },
];

export const adanceddeftodaydata = [
  { name: "Au lundi", id: "2" },
  { name: "Au mardi", id: "3" },
  { name: "Au mercredi", id: "4" },
  { name: "Au jeudi", id: "5" },
  { name: "Au vendredi", id: "6" },
  { name: "Au samedi", id: "7" },
  { name: "Au dimanche", id: "1" },
];

export const adanceddefhourdata = [
  { name: "0h", id: "0" },
  { name: "1h", id: "1" },
  { name: "2h", id: "2" },
  { name: "3h", id: "3" },
  { name: "4h", id: "4" },
  { name: "5h", id: "5" },
  { name: "6h", id: "6" },
  { name: "7h", id: "7" },
  { name: "8h", id: "8" },
  { name: "9h", id: "9" },
  { name: "10h", id: "10" },
  { name: "11h", id: "11" },
  { name: "12h", id: "12" },
  { name: "13h", id: "13" },
  { name: "14h", id: "14" },
  { name: "15h", id: "15" },
  { name: "16h", id: "16" },
  { name: "17h", id: "17" },
  { name: "18h", id: "18" },
  { name: "19h", id: "19" },
  { name: "20h", id: "20" },
  { name: "21h", id: "21" },
  { name: "22h", id: "22" },
  { name: "23h", id: "23" },
];

export const granularitydata = [
  { name: "10 minutes", id: "10minutes" },
  { name: "Horaire", id: "hour" },
  { name: "Journalier", id: "day" },
  { name: "Hebdomadaire", id: "week" },
  { name: "Mensuel", id: "month" },
  { name: "Annuel", id: "year" },
];

export const heatmapdisplaydata = [
  { name: "heure / jour", id: "hourday" },
  // { name: "jour / semaine", id: "dayweek" },
  { name: "jour / mois", id: "daymonth" },
  // { name: "mois / année", id: "monthyear" },
];

export const heatmapcolordata = [
  { name: "bleu vers rouge", id: "bluered" },
  { name: "blanc vers bleu", id: "whiteblue" },
];

export const distributiondata = [
  { name: "Pas de distribution", id: "no" },
  { name: "Site", id: "site" },
  { name: "Bâtiment", id: "batiment" },
  { name: "Zone", id: "zone" },
  { name: "Compte", id: "compte" },
  { name: "Région", id: "région" },
  { name: "Equipement urbain", id: "equrbain" },
  { name: "EPCI", id: "epci" },
  { name: "Groupe", id: "groupe" },
  { name: "Commune", id: "commune" },
];


export const chartseriesourceData = [
  { name: "Point de donnée", id: "point" },
  { name: "Type de donnée", id: "definition" },
  { name: "Valeur fixe", id: "fixedvalue" },
]


export const chartfixedvaluetypeData = [
  { name: "Valeur fixe", id: "fixed" },
  { name: "Valeur du patrimoine", id: "realestate" },
]

export const chartaxisData = [
  { name: "Axe de gauche", id: "left" },
  { name: "Axe de droite", id: "right" },
]

export const realestatevalueData = [
  { name: "Seuil CO2 qualité d’air modérée", id: "moderateairqualityco2threshold" },
  { name: "Seuil CO2 qualité d’air basse", id: "lowairqualityco2threshold" },
  { name: "Température réduite", id: "reducedtemperature" },
  { name: "Température de confort", id: "comforttemperature" },
  { name: "Limite environnement sec", id: "lowhumiditylevel" },
  { name: "Limite environnement humide", id: "highhumiditylevel" },
]

export const chartcolors = [
  { name: "Rouge", id: "url(#colorRed)" },
  { name: "Orange", id: "url(#colorOrange)" },
  { name: "Jaune", id: "url(#colorYellow)" },
  { name: "Vert", id: "url(#colorGreen)" },
  { name: "Bleu", id: "url(#colorBlue)" },
  { name: "Violet", id: "url(#colorPurple)" },
  { name: "Gris", id: "url(#colorGrey)" },
  { name: "DPE A", id: "url(#dpeA)" },
  { name: "DPE B", id: "url(#dpeB)" },
  { name: "DPE C", id: "url(#dpeC)" },
  { name: "DPE D", id: "url(#dpeD)" },
  { name: "DPE E", id: "url(#dpeE)" },
  { name: "DPE F", id: "url(#dpeF)" },
  { name: "DPE G", id: "url(#dpeG)" },
]

export const distributiongroupmentdata = {
  site:
    [
      { name: "Aucune", id: "no" },
      { name: "Activité du site", id: "parameters.activity.activitytype" },
    ],
  batiment:
    [
      { name: "Aucune", id: "no" },
      { name: "Activité du bâtiment", id: "parameters.activity.activitytype" },
    ],
  zone:
    [
      { name: "Aucune", id: "no" },
      { name: "Activité de la zone", id: "parameters.activity.activitytype" },
    ],
  compte:
    [
      { name: "Aucune", id: "no" },
      { name: "Activité du compte", id: "parameters.activity.activitytype" },
    ],
  région:
    [
      { name: "Aucune", id: "no" },
      { name: "Activité de la région", id: "parameters.activity.activitytype" },
    ],
  commune:
    [
      { name: "Aucune", id: "no" },
      { name: "Activité de la commune", id: "parameters.activity.activitytype" },
    ],
  equrbain:
    [
      { name: "Aucune", id: "no" },
      { name: "Activité de l'équipement", id: "parameters.activity.activitytype" },
    ],
  epci:
    [
      { name: "Aucune", id: "no" },
      { name: "Activité de l'EPCI", id: "parameters.activity.activitytype" },
    ],
  groupe:
    [
      { name: "Aucune", id: "no" },
      { name: "Activité du groupe", id: "parameters.activity.activitytype" },
    ],
};

